import moment from "moment"
import React, { useEffect, useState } from "react"
import { Col, Row, Table } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png"
import Navbar from "../../../Components/Navbar/Navbar"
import ElmhurstLogo from "../../../Assets/Images/elmhurst-initial-logo.png"
import {
  formatDecimal,
  getCurrentDateTimeYYMMDDHHMMSS,
  dateFormat,
  isAdmin,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import {
  getSalesQuotation,
  emailSalesQoutation,
} from "../../../Helpers/apiCalls/SalesModule/SalesQuotationApi"
import Footer from "../../../Components/Footer/Footer"
import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import SalesModal from "../Component/SalesModal"

export default function SalesQuotationPrint() {
  const { id } = useParams() // id
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [salesInvoice, setSalesInvoice] = useState([])
  const [items, setItems] = useState([])
  const [paymentInfo, setPaymentInfo] = useState([])
  const [showSendModal, setShowSendModal] = useState(false)
  const handleShowSendModal = () => setShowSendModal(true)
  const handleCloseSendModal = () => setShowSendModal(false)
  const [prepBySignature, setPrepBySignature] = useState()
  const [isClicked, setIsClicked] = useState(false)

  async function fetchSaleQuotation() {
    setSalesInvoice({})
    setPaymentInfo([])
    setItems([])

    const response = await getSalesQuotation({ id: id })

    if (response.error) {
      TokenExpiry(response)
    } else {
      var details = response.data.data[0]
      details.subtotal = response.data.data[0].sales_quotation_items
        .map((item) => item.subtotal)
        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
      setSalesInvoice(details)
      setItems(details.sales_quotation_items)

      // console.log(items)

      var payment = details.sales_quotation_payments?.map((data) => {
        if (data.paid_amount !== "0.00") {
          var info = data
          info.paid_amount = numberFormat(data.paid_amount)
          info.deposit_amount = response.data.deposit_amounts[info.payment_no]
            ? numberFormat(response.data.deposit_amounts[info.payment_no])
            : ""
          if (data.payment_type === "check") {
            info.payment_type = data.payment_type + "-" + data.cheque_number
          }
          setPaymentInfo((prev) => [...prev, info])
          return info
        }
      })
    }
  }

  const handleSendEmail = async (ref) => {
    if (ref) {
      const element = document.getElementById(ref)
      setIsClicked(true)

      html2canvas(element).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7) // Adjust the quality here (0.7 is just an example)
        const pdf = new jsPDF()
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = pdf.internal.pageSize.getHeight()
        const imgWidth = canvas.width
        const imgHeight = canvas.height
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
        const imgX = (pdfWidth - imgWidth * ratio) / 2
        const imgY = 5
        pdf.addImage(
          imgData,
          "JPEG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        )

        // Convert the pdf file from Blob to File obj (needed for upload API)
        var blobPdf = pdf.output("blob")

        const dateToday = getCurrentDateTimeYYMMDDHHMMSS()
        const formPdf = new File(
          [blobPdf],
          `Sales_Quotation_${dateToday}.pdf`,
          {
            type: blobPdf.type,
          }
        )

        // if (printPO.supplier_email || printPO.vendor_email) {
        const response = await emailSalesQoutation(id, formPdf)

        if (response.response) {
          toast.success(response.response.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/salesquotation", {
              params: {
                state: "sent",
              },
            })
          }, 1000)
        } else {
          setIsClicked(false)
          toast.error("Email not sent", {
            style: toastStyle(),
          })
          setTimeout(() => {
            setIsClicked(false)
            handleCloseSendModal()
          }, 1000)
        }
        // }
      })
    }
  }

  async function convertFromHtmlToImage() {
    const preparedBySignatureLink = salesInvoice.added_by_name_signature
    try {
      const prepByBase64Data = await imageUrlToBase64(preparedBySignatureLink)
      setPrepBySignature(prepByBase64Data)
    } catch {}
  }

  async function imageUrlToBase64(url) {
    try {
      const response = await fetch(url)
      const blob = await response.blob()
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      return null
    }
  }

  convertFromHtmlToImage()

  async function handlePrint() {
    toast.loading("Printing sales quotation...", { style: toastStyle() })
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }
  async function handlePrintWarehouse() {
    toast.loading("Printing sales quotation for warehouse...", {
      style: toastStyle(),
    })
    setTimeout(() => {
      toast.dismiss()
      PrintWarehouse()
    }, 1000)
  }

  useEffect(() => {
    convertFromHtmlToImage()
  }, [])

  console.log(items)

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th></th>
            <th>Item Code</th>
            <th>Product</th>
            <th className="text-end">Quantity</th>
            <th>U o M</th>
            <th>Size</th>
            <th className="text-end">Price/Unit</th>
            <th className="text-end">Discount</th>
            <th className="text-end">Amount</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index} className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides">{index + 1}</td>
                <td className="req-table-w-border-sides">{item.item_code}</td>
                <td className="req-table-w-border-sides">
                  {item.description
                    ? item.item_name
                      ? item.description + " - " + item.item_name
                      : item.description
                    : item.item_name}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {Math.floor(item.qty)}
                </td>
                <td className=" req-table-w-border-sides">{item.unit}</td>
                <td className=" req-table-w-border-sides">{item.item_size}</td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.price)}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {/* {numberFormat(parseFloat(item.discount))}%
                  {item.discount} */}
                  {`${numberFormat(
                    item.price * item.qty - item.subtotal
                  )}(${formatDecimal(item.discount || 0)}%)`}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.subtotal)}
                </td>
                <td className="req-table-w-border-sides">
                  {item.item_remarks}
                </td>
              </tr>
            )
          })}
          <tr>
            <td colSpan={7}>
              <div>{/* <hr /> */}</div>
            </td>
          </tr>
          {/* <tr>
                        <td colSpan={5}></td>
                        <td className="left">Subtotal</td>
                        <td className="right">
                            {salesInvoice.subtotal
                                ? numberFormat(salesInvoice.subtotal)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">Service Fee</td>
                        <td className="right">
                            {salesInvoice.service_fee
                                ? numberFormat(salesInvoice.service_fee)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">Delivery Fee</td>
                        <td className="right">
                            {salesInvoice.delivery_fee
                                ? numberFormat(salesInvoice.delivery_fee)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">GRAND TOTAL</td>
                        <td className="right">
                            {salesInvoice.grand_total
                                ? numberFormat(salesInvoice.grand_total)
                                : "0.00"}
                        </td>
                    </tr> */}
        </tbody>
      </Table>
    )
  }

  function renderWarehouseTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Transfer Qty</th>
            <th>Item</th>
            <th>Unit</th>
            <th className="text-end">Quantity</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides"></td>
                <td className="req-table-w-border-sides">{item.item_name}</td>
                <td className="text-lowercase req-table-w-border-sides">
                  {item.unit}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.qty)}
                </td>
                <td className="req-table-w-border-sides"></td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }
  function PrintWarehouse() {
    let printContents = document.getElementById(
      "printabledivwarehouse"
    ).innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  //
  useEffect(() => {
    fetchSaleQuotation()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WHOLESALE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <br />
        <br />
        <div className="print-container px-3 py-2" id="printablediv">
          {/* <div
                        className={
                            salesInvoice.fs_status === "invoiced"
                                ? "text-end print-header d-flex flex-column"
                                : "text-start print-header d-flex flex-column"
                        }
                    >   <span>SALES QUOTATION NO. {id}</span>
                        <span className="text-uppercase">
                            {moment(salesInvoice.added_on).format("MMMM DD, yyyy")}
                        </span>
                    </div> */}
          <div className="print-header-invoice-elm">
            <div className="d-flex justify-content-center py-1">
              <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
            </div>
            <div className="print-top">
              <h5 className="print-shop-header-elm d-flex justify-content-center">
                497 D Molave Extension, Lahug, Cebu City
              </h5>
              {/* <h5 className="print-shop-header-elm d-flex justify-content-center">San Roque, Cebu City</h5> */}
            </div>
          </div>
          <div className="print-header2-invoice-container mt-5">
            <div className="invoice-header2-left d-flex flex-column gap-1">
              <h2 className="delivery-title-elm">SALES QUOTATION</h2>
              <h4 className="receiver-name-elm print-data fw-bold fs-5">
                Customer: {salesInvoice.customer_name}
              </h4>
              <h5 className="print-pi-tin-elm print-data">
                TIN: {salesInvoice.customer_tin}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Branch: {salesInvoice.branch_name}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Address: {salesInvoice.address}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Contact No.: {salesInvoice.contact_no}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Terms: {salesInvoice.terms} days
              </h5>
            </div>
            <div className="invoice-header2-right">
              <div className="invoice-header2-right-left">
                <h5 className="text-end print-table-footer-label">
                  Quotation No.:{" "}
                </h5>
                <h5 className="text-end print-table-footer-label">Date: </h5>
                <h5 className="text-end print-table-footer-label">Status: </h5>
                <h5 className="text-end print-table-footer-label">
                  Valid From:{" "}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  Valid To:{" "}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  Ship Via:{" "}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  Delivery Date:{" "}
                </h5>
              </div>
              <div className="invoice-header2-right-right mt-1">
                <h5 className="text-start print-table-footer-label">{id}</h5>
                <h5 className="text-start print-table-footer-label">
                  {moment(salesInvoice.added_on).format("MMMM DD, yyyy")}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {salesInvoice.status}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {dateFormat(salesInvoice.valid_from)}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {dateFormat(salesInvoice.valid_to)}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {salesInvoice.ship_via === "pick_up"
                    ? "Pick Up"
                    : salesInvoice.ship_via}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {dateFormat(salesInvoice.delivery_date)}
                </h5>
              </div>
            </div>
          </div>

          {/* content */}
          <div className=" mt-5 justify-content-start">
            {/* <Row className="d-flex align-items-start ms-5">
                            <Col>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Customer:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.customer_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Branch:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.branch_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Valid From:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {dateFormat(salesInvoice.valid_from)}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Valid To:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {dateFormat(salesInvoice.valid_to)}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Status:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.status}
                                    </Col>
                                </div>
                            </Col>
                            <Col>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Ship Via:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.ship_via === "pick_up" ? "Pick Up" : salesInvoice.ship_via}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Delivery Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {dateFormat(salesInvoice.delivery_date)}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Contact No.:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.contact_no}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Address:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.address}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Remarks:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.remarks}
                                    </Col>
                                </div>
                            </Col>
                        </Row> */}
            <div className="d-flex mt-2 justify-content-evenly">
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>
            <Row className="mt-2">
              <span className="print-footer">
                for additional orders call 0917-511-1171
              </span>
            </Row>
            {salesInvoice.remarks && (
              <Row className="mt-2 ml-5">
                <span className="print-pi-address-elm print-data">
                  {" "}
                  Remarks: {salesInvoice.remarks}
                </span>
              </Row>
            )}
            <div className="d-flex flex-row gap-3 justify-content-end mx-3 mt-4">
              <div className="d-flex flex-column">
                <h5 className="text-end print-table-footer-label">subtotal:</h5>
                <h5 className="text-end print-table-footer-label">
                  service fee:
                </h5>
                <h5 className="text-end print-table-footer-label">
                  delivery fee:
                </h5>
                <h5 className="text-end print-table-footer-label bold">
                  grand total:
                </h5>
              </div>
              <div>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.subtotal
                    ? numberFormat(salesInvoice.subtotal)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.service_fee
                    ? numberFormat(salesInvoice.service_fee)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.delivery_fee
                    ? numberFormat(salesInvoice.delivery_fee)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.grand_total
                    ? numberFormat(salesInvoice.grand_total)
                    : "0.00"}
                </h5>
              </div>
            </div>

            {/* <Row className="print-grand-total my-3 text-end">
              <Col xs={3} lg={11} className="print-table-footer-label">
                SUBTOTAL
              </Col>
              <Col xs={2} lg={1} className="print-table-footer-data text-end">
                {salesInvoice.subtotal
                  ? numberFormat(salesInvoice.subtotal)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-3 text-end">
              <Col xs={3} lg={11} className="print-table-footer-label ">
                SERVICE FEE
              </Col>
              <Col xs={2} lg={11} className="print-table-footer-data text-end">
                {salesInvoice.service_fee
                  ? numberFormat(salesInvoice.service_fee)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-3 text-end">
              <Col xs={3} className="print-table-footer-label ">
                DELIVERY FEE
              </Col>
              <Col xs={2} className="print-table-footer-data text-end">
                {salesInvoice.delivery_fee
                  ? numberFormat(salesInvoice.delivery_fee)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-3 text-end">
              <Col xs={3} className="print-table-footer-label ">
                GRAND TOTAL
              </Col>
              <Col xs={2} className="print-table-footer-data text-end">
                {salesInvoice.grand_total
                  ? numberFormat(salesInvoice.grand_total)
                  : "0.00"}
              </Col>
            </Row> */}
            {/* <Row className="print-grand-total mt-3 text-end">
                            <Col xs={8} lg={9} md={6} className="bold print-table-footer-label">
                                <span className="cheque-pay-to">Cheque pay to ELHMHURST ENTERPRISES COMPANY</span>
                            </Col>
                        </Row> */}
            {/* <Row className="mt-2 ms-5">
              <span className="print-footer">{salesInvoice.remarks}</span>
            </Row> */}
            <Row className="mt-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img
                  //   src={salesInvoice.added_by_name_signature}
                  src={prepBySignature}
                  className="print-logo"
                  alt=""
                />
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                {/* <img src={request.approved_by_name_signature} className="print-logo" alt=""/> */}
              </Col>
            </Row>
            <Row className="mt-2 mb-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  {/* {salesInvoice.added_by_name}
                  <div className="margin-underline"></div>
                  Prepared by */}
                  <p className="print-data underline-border text-center">
                    {salesInvoice.added_by_name}
                  </p>
                  <p className="print-data text-center mt-2">Prepared by</p>
                </Row>
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham pt-3">
                  {/* {salesInvoice.client}
                  <div className="margin-underline"></div>
                  Noted by (Client) */}
                  <p className="print-data underline-border text-center">
                    {salesInvoice.client}
                  </p>
                  <p className="print-data text-center mt-2">Noted by</p>
                </Row>
              </Col>
            </Row>
          </div>
        </div>

        {/* footer */}
        <div className="d-flex justify-content-end my-4 pb-5 flex-column gap-2 flex-md-row">
          <button
            className="button-secondary"
            onClick={() => navigate("/salesquotation")}
          >
            Close
          </button>
          <button className="button-tertiary" onClick={handleShowSendModal}>
            Send to Customer
          </button>
          {salesInvoice.payment_status === "open_bill" && isAdmin() ? (
            <button
              className="button-primary"
              onClick={() => navigate("/salesquotation/edit/" + id)}
            >
              Edit
            </button>
          ) : (
            ""
          )}
          {salesInvoice.fs_status === "processing" && (
            <button className="button-primary" onClick={handlePrintWarehouse}>
              Print Warehouse
            </button>
          )}
          {/* <button className="button-primary me-3" >
                        Email to Supplier
                    </button> */}
          <button className="button-primary" onClick={handlePrint}>
            Print
          </button>
        </div>
      </div>
      <div
        className="print-container px-3 py-2 display-none"
        id="printabledivwarehouse"
      >
        <div
          className={
            salesInvoice.fs_status === "invoiced"
              ? "text-end print-header d-flex flex-column"
              : "text-start print-header d-flex flex-column"
          }
        >
          <span>SALES QUOTATION NO. {id}</span>
          <span className="text-uppercase">
            {moment(salesInvoice.added_on).format("MMMM DD, yyyy")}
          </span>
        </div>
        <div className="d-flex justify-content-center py-1">
          <img alt="logo" src={cleanLogo} className="print-logo" />
        </div>

        {/* content */}
        <div className="mt-5 justify-content-start">
          <Row className="d-flex align-items-start ms-5">
            <Col>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Customer:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.customer_name}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Branch:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.branch_name}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Valid From:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.valid_from}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Valid To:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.valid_to}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Status:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.status}
                </Col>
              </div>
            </Col>
            <Col>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Ship Via:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.ship_via === "pick_up"
                    ? "Pick Up"
                    : salesInvoice.ship_via}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Delivery Date:
                </Col>
                <Col xs={7} className="print-data">
                  {dateFormat(salesInvoice.delivery_date)}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Contact No.:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.contact_no}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Address:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.address}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Remarks:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.remarks}
                </Col>
              </div>
            </Col>
          </Row>
          <div className="d-flex mt-2 justify-content-evenly">
            {/* table */}
            <div className="print-table mt-3 mx-2">
              {renderWarehouseTable()}
            </div>
          </div>

          {/* <Row className="mt-2 ms-5">
            <span className="print-footer">{salesInvoice.remarks}</span>
          </Row> */}
          {/* <Row className="mt-2">
                        <Col xs={6} className="print-sig justify-content-center d-flex">
                        </Col>
                        <Col xs={6} className="print-sig justify-content-center d-flex">
                            <img alt="esig" src={signature} className="print-logo" />
                        </Col>
                    </Row> */}
          <Row className="mt-2 mb-5">
            <Col xs={6} className="print-sig justify-content-center d-flex">
              <Row className="print-sig justify-content-center gotham">
                <p className="print-data underline-border">
                  {salesInvoice.added_by_name}
                </p>
                <p className="print-table-footer-label">Prepared by</p>
              </Row>
            </Col>
            <Col xs={6} className="print-sig justify-content-center d-flex">
              <Row className="print-sig justify-content-center gotham">
                <p className="print-data">{salesInvoice.client}</p>
                <p className="print-data"> Noted by (Client)</p>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
      <SalesModal
        show={showSendModal}
        hide={handleCloseSendModal}
        message="Are you sure you want to send this sales qoutation to the customer?"
        handler={() => handleSendEmail("printablediv")}
        isClicked={isClicked}
      />
    </div>
  )
}
